import React from 'react'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'

import Icon from '../../../../../../components/UI/Icon'
import { styled } from '@mui/material/styles'

const JobsPostActionsInfoTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#FDFDFD',
    color: '#F67443',
    boxShadow: '0px 8px 16px 0px rgba(0, 0, 0, 0.25)',
    padding: 32,
    borderRadius: 20,
    borderColor: '#F79009',
    borderWidth: 1,
    minWidth: 498,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
  },
}))

const JobsPostActionsInfo = () => {
  return (
    <JobsPostActionsInfoTooltip
      title={
        <div className="w-full flex flex-col items-start gap-y-[20px]">
          <div className="w-full flex flex-col items-start">
            <span className="text-sm font-semibold">Activate</span>

            <p className="text-sm mt-[2px]">
              By clicking “Activate”, you will have to pay €1.99 for creating your Job Post at the
              posts page.
            </p>
          </div>

          <div className="w-full flex flex-col items-start">
            <span className="text-sm font-semibold">Renewal</span>

            <p className="text-sm mt-[2px]">
              By clicking “Renewal,” your post will be renewed every 24 hours for €1.99. It will
              help keep your job post up on the posts page.
            </p>
          </div>

          <div className="w-full flex flex-col items-start">
            <span className="text-sm font-semibold">Promote</span>

            <p className="text-sm mt-[2px]">
              By clicking “Promote, your Job Post will always be on the top of other posts for the
              price of €9.99, paid once. the post will have a “Promoted” label at your Post Banner.
            </p>
          </div>
        </div>
      }
    >
      <div className="ml-[10px]">
        <Icon name="info" color="#F79009" className="w-[24px] h-[24px]" />
      </div>
    </JobsPostActionsInfoTooltip>
  )
}

export default JobsPostActionsInfo
